<template>
    <li class="nav-item dropdown">
        <a class="d-flex align-items-center nav-link dropdown-toggle"
        id="alertDropdown"
        href="#"
        data-toggle="dropdown"
        aria-expanded="false">
            <button type="button" class="btn bg-transparent position-relative m-0 p-0">
                <app-icon :name="'bell'"/>
                <span v-if="alerts.length > 0" class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                    {{ alerts.length }}
                </span>
            </button>
        </a>
        <div class="dropdown-menu dropdown-menu-right navbar-dropdown" aria-labelledby="alertDropdown">
            <div class="d-flex">
                <div class="dropdown-header w-25">Product</div>
                <div class="dropdown-header w-25">Qty</div>
                <div class="dropdown-header w-25">Branch/Warehouse</div>
                <div class="dropdown-header w-25">Expiration</div>
            </div>
            <div v-for="alert in alerts">
                <div class="dropdown-item d-flex">
                    <div class="w-25">
                        <stock-profile :rowData="alert" :key="alert.name" />
                    </div>
                    <div class="w-25 font-size-default ml-4">
                        <p class="my-2 text-black">{{ alert.available_qty }}</p>
                    </div>
                    <div class="w-25 font-size-default ml-4">
                        <p class="my-2 text-black">{{ alert.branch_or_warehouse.name }}
                            <span :class="`text-${alert.branch_or_warehouse.type && alert.branch_or_warehouse.type.toLowerCase() === 'branch' ? 'warning' : 'info'}`"> ({{ alert.branch_or_warehouse.type ? alert.branch_or_warehouse.type[0].toUpperCase() : '' }})</span>
                        </p>
                    </div>
                    <div class="w-25 font-size-default ml-4">
                        <p class="my-2 text-black">{{ alert.variant.product.expiration_date }}</p>
                    </div>
                </div>
                <div class="dropdown-divider"/>
            </div>
        </div>
    </li>
</template>



<script>
    export default {
        name: "AlertDropdown",
        props: {
            alerts: {
                type: Array,
                required: true
            },
        }
    }
</script>
